import { useEffect, useState } from 'react';
import { Box, Button, Divider, IconButton, Stack, Tooltip,  useMediaQuery } from '@mui/material';
import {  useForm } from 'react-hook-form';
import { Icon as Iconify } from '@iconify/react';
import { useLocation, useParams } from 'react-router-dom';



import { useSchemeStore } from '../schemeStore';
import { renderControls } from '../utils/renderControls';

import SchemePointDataGrid from '../Others/SchemePointDataGrid';
import schemedefinationService from '../../../services/schemedefination.service';
import LoadingProgressBar from '../../../components/loading-progressbar/loadingprogressbar';
import PopUpHandle from '../../../commons/PopUpHandle';
import { useSchemeSavePermission } from '../utils/useSchemeSavePermission';



export default function SchemePoint() {
    const location = useLocation();
    const isCopyScheme = location.state?.data?.copyScheme;
    const canSaveScheme = useSchemeSavePermission(isCopyScheme);


    const {
        schemeDetails,
        prevTabValue,
        tabValue,
        setPointData,
        updateScheme,
        addScheme
    } = useSchemeStore();


    const { id } = useParams();


    ;
    const [schemePointControls, setSchemePointControls] = useState([]);
    const [gridData, setGridData] = useState([]);
    const isSmallScreen = useMediaQuery('(max-width:600px)');


    const [open, setOpen] = useState(false);
    const [error, setError] = useState(0);
    const [errorCode, setErrorCode] = useState(null);


    const handleClose = () => {
        setOpen(false);
    };


    const getObject = (key, value, controls) => {
        if (key === 'ItemId') {
            // Find the control with the appropriate ValueExpr (key matches)
            let controll;
            if (controls != null) {

                controll = controls?.find(item => item?.ValueExpr === key);
            } else {
                controll = schemePointControls?.find(item => item?.ValueExpr === key);
            }

            // Find the matching DefaultValues entry

            let items;
            // Find the matching DefaultValues entry
            if (Array.isArray(value)) {
                items = controll?.DefaultValues?.filter(item => value?.includes(item[key])); // Ensure type match

            } else {

                items = controll?.DefaultValues?.find(item => Number(item[key]) === Number(value)); // Ensure type match
            }
            return items;
        }

        return null;
    };




    const {
        handleSubmit,
        control,

        watch,

        setValue

    } = useForm();

    const values = watch();

    useEffect(() => {
         //  console.log("values: ", values);

    }, [values]);

    const [loadingCount, setLoadingCount] = useState(0);
    const showLoading = () => setLoadingCount((prev) => prev + 1);
    const hideLoading = () => setLoadingCount((prev) => Math.max(prev - 1, 0));

    useEffect(() => {
        if (Array.isArray(schemeDetails?.Point) && schemeDetails.Point[0] != null) {

            const formValues = {}; // Initialize an empty object

            Object.entries(schemeDetails.Point[0]).forEach(([key, value]) => {
                if (key === 'ItemDefinition') {
                    const newValue = value?.map(item => item?.ItemId).filter(Boolean);
                    setValue('ItemId', newValue)
                    formValues.ItemId = newValue;
                } else {
                    setValue(key, value)
                    formValues[key] = value; // Add other keys directly
                }
            });
             //  console.log("##formValues: ", formValues);
            const rowData = Object.fromEntries(
                Object.entries(formValues).map(([key, value]) => [
                    key,
                    String(key).includes('Id' || 'id') ? getObject(key, value, schemePointControls) : value
                ])
            );



             //  console.log("rowData: ", rowData);

            if (rowData?.ItemId) {
                // Retrieve current grid data
                const currentGridData = gridData; // Assuming this is the current grid data.

                // Filter out any existing ItemId in the current grid data
                const newItems = rowData.ItemId.filter(item =>
                    !currentGridData.some(existingItem => existingItem.ItemId === item.ItemId)
                );

                // Add mt and point value to each new item
                const updatedNewItems = newItems.map((item, index) => ({
                    ...item,
                    id: currentGridData.length + index, // start indexing after the indexes of the current griddata indexes
                    MT: schemeDetails?.Point[0].ItemDefinition[index].ItemMT,  // Set your desired value for 'mt'
                    Point: schemeDetails?.Point[0].ItemDefinition[index].ItemPT, // Set your desired value for 'point'
                }));

                // Add only new items
                if (updatedNewItems.length > 0) {
                    setGridData([...currentGridData, ...updatedNewItems]);
                }
                 //  console.log('from useEffect1: ', [...currentGridData])
                 //  console.log('from useEffect2: ', [...updatedNewItems])
            }

        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [schemeDetails]);

    const getSchemePointControls = async () => { // NOSONAR
        try {
            showLoading();
            const schemeDefinationInstance = await schemedefinationService; // Ensure this is imported correctly
            if (!schemeDefinationInstance) {
                throw new Error("schemedefinationService instance is not available");
            }

            const response = await schemeDefinationInstance.GetSchemePointControls(id);
            setSchemePointControls(response.data);

            if (Array.isArray(schemeDetails?.Point) && schemeDetails?.Point[0] != null) {

                const formValues = {}; // Initialize an empty object

                Object.entries(schemeDetails?.Point[0]).forEach(([key, value]) => {
                    if (key === 'ItemDefinition') {
                        const newValue = value?.map(item => item?.ItemId).filter(Boolean);
                        setValue('ItemId', newValue)
                        formValues.ItemId = newValue;
                    } else {
                        setValue(key, value)
                        formValues[key] = value; // Add other keys directly
                    }
                });
                 //  console.log("##formValues: ", formValues);
                const rowData = Object.fromEntries(
                    Object.entries(formValues).map(([key, value]) => [
                        key,
                        String(key).includes('Id' || 'id') ? getObject(key, value, response.data) : value
                    ])
                );

                if (rowData?.ItemId) {
                    // Retrieve current grid data
                    const currentGridData = gridData; // Assuming this is the current grid data.

                    // Filter out any existing ItemId in the current grid data
                    const newItems = rowData.ItemId.filter(item =>
                        !currentGridData.some(existingItem => existingItem.ItemId === item.ItemId)
                    );

                    // Add mt and point value to each new item
                    const updatedNewItems = newItems.map((item, index) => ({
                        ...item,
                        id: currentGridData.length + index, // start indexing after the indexes of the current griddata indexes
                        MT: schemeDetails?.Point[0].ItemDefinition[index].ItemMT,  // Set your desired value for 'mt'
                        Point: schemeDetails?.Point[0].ItemDefinition[index].ItemPT, // Set your desired value for 'point'
                    }));

                    // Add only new items
                    if (updatedNewItems.length > 0) {
                        setGridData([...currentGridData, ...updatedNewItems]);
                    }
                     //  console.log('setGridData: ', [...currentGridData, ...updatedNewItems])
                }

            }
        } catch (err) {
            setErrorCode(err?.response?.data?.error?.code);
            setError(err?.response?.data?.error?.message);
            setOpen(true);
        } finally {
            hideLoading();
        }
    };

    useEffect(() => {
        if (schemePointControls.length === 0) {
            getSchemePointControls();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [schemeDetails]); // Dependency array ensures the effect runs only when schemePointControls changes



    const onSubmit = (formData) => {
        const rowData = Object.fromEntries(
            Object.entries(formData).map(([key, value]) => [
                key,
                String(key).includes('Id' || 'id') ? getObject(key, value) : value
            ])
        );
    
        if (rowData?.ItemId) {
            const newSelection = rowData.ItemId;
            const currentGridData = gridData;
    
            const updatedGridItems = newSelection.map((selectedItem, index) => {
                const existingItem = currentGridData.find(gridItem => gridItem.ItemId === selectedItem.ItemId);
    
                if (existingItem) {
                    // If item already exists, keep its existing values
                    return existingItem;
                } 
                    // If it's a new item, add it with empty MT and Point
                    return {
                        ...selectedItem,
                        id: currentGridData.length + index, // Ensure unique ID
                        MT: '',      // Set your desired value for 'mt'
                        Point: ''    // Set your desired value for 'point'
                    };
                
            });
    
            setGridData(updatedGridItems);
        } else {
            // If no items are selected, clear the grid
            setGridData([]);
        }
    };
    const [showErrorMessage, setShowErrorMessage] = useState(false);


    useEffect(() => {
        if (prevTabValue.name === 'Point') {
            formDataSave();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tabValue]);

    const formDataSave = async () => {

         //  console.log("saveData");
        setShowErrorMessage(true);
        if (values?.MetricTon && values?.Point) {

            let isValid = true; // Flag to track validity
            let payload;

            if (gridData?.lenth === 0) {
                payload = [
                    {
                        "MetricTon": values?.MetricTon,
                        "Point": values?.Point,
                    }
                ];

                setPointData(payload);


            } else {
                gridData.forEach(item => {

                    if (item.MT === '' || item.Point === '') {
                        isValid = false; // Set the flag to false if any item is invalid


                        setPointData('error');

                    }
                });

                if (isValid) {
                    payload = [
                        {
                            "MetricTon": values?.MetricTon,
                            "Point": values?.Point,
                            "ItemDefinition": gridData.map(item => ({
                                "ItemId": item?.ItemId,
                                "ItemMT": item?.MT,
                                "ItemPT": item?.Point,
                            }))
                        }
                    ];


                    setPointData(payload);

                }



            }

        } else if (!!values?.MetricTon !== !!values?.Point) {
                setPointData('error');
           
        } else {
            setPointData(null);
        }

      
    }




    const saveData = async () => { // NOSONAR
        setShowErrorMessage(true);
        if (values?.MetricTon && values?.Point) {

            let isValid = true; // Flag to track validity
            let payload;

            if (gridData?.lenth === 0) {
                payload = [
                    {
                        "MetricTon": values?.MetricTon,
                        "Point": values?.Point,
                    }
                ];

                setPointData(payload);


            } else {
                gridData.forEach(item => {

                    if (item.MT === '' || item.Point === '') {
                        isValid = false; // Set the flag to false if any item is invalid


                        setPointData('error');

                    }
                });

                if (isValid) {
                    payload = [
                        {
                            "MetricTon": values?.MetricTon,
                            "Point": values?.Point,
                            "ItemDefinition": gridData.map(item => ({
                                "ItemId": item?.ItemId,
                                "ItemMT": item?.MT,
                                "ItemPT": item?.Point,
                            }))
                        }
                    ];


                    setPointData(payload);

                }



            }

        } else if (!!values?.MetricTon !== !!values?.Point) {
            setPointData('error');
            return;

        } else {
            setPointData(null);
        }
        try {
            if (isCopyScheme) { 
                const result = await addScheme(); // NOSONAR
            } else {

                const result = await updateScheme(); // NOSONAR
            }
        } catch (err) {
            // handle error
        }
    };



    return (

        <div style={{ height: '100%', display: 'flex', flexDirection: 'column', flexGrow: 1 }} key={schemeDetails}>
            <form onSubmit={handleSubmit(onSubmit)} style={{ minHeight: 0, display: 'flex', flexDirection: 'column', flexGrow: 1, }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', flexGrow: 1, minHeight: 0, justifyContent: 'space-between', overflow: isSmallScreen ? 'auto' : 'hidden', }}>

                    <Box >
                        <Box
                            rowGap={2}
                            columnGap={2}
                            display="grid"
                            gridTemplateColumns={{
                                xs: 'repeat(1, 1fr)',
                                sm: 'repeat(3, 1fr)',
                            }}
                            gridAutoRows='min-content'

                            sx={{ mt: 1, paddingTop: '0.4rem', }}

                        >
                            {
                                schemePointControls && schemePointControls.length > 0 &&
                                schemePointControls?.map((field, index) => renderControls(field, index, control, null))
                            }



                        </Box>
                        <Stack
                            direction="row"
                            justifyContent="flex-end"
                            alignItems="center"
                            sx={{ py: 1 }}

                        >
                            <Button type='submit'
                                title='Add'
                                variant='contained'
                                sx={{
                                    height: '30px',
                                    width: '31px',
                                    bgcolor: '#1badd1',
                                    borderRadius: '4px',
                                    minWidth: 'auto',
                                    fontSize: '25px',
                                    '&:hover': {
                                        bgcolor: '#1badd1',
                                    },
                                }}
                            >
                                +
                            </Button>
                        </Stack>

                    </Box>
                    <Box style={{ flexGrow: 1, overflow: 'auto', }}>

                        <SchemePointDataGrid gridData={gridData} setGridData={setGridData} key={schemeDetails} showErrorMessage={showErrorMessage} />

                    </Box>
                </Box>
                

                {/* Divider */}
                <Divider sx={{ mt: 2 }} />

                {/* Save button fixed at the bottom */}
                <Box sx={{ mt: 1 }}>
                    <Stack
                        direction="row"
                        justifyContent="flex-end"
                        spacing={2}
                        alignItems="center"
                        sx={{ padding: '2px' }}
                    >
                        {schemeDetails?.SchemeLock !== true && canSaveScheme && (
                            <Tooltip title="Save">
                                <IconButton type='button' onClick={() => saveData()} sx={{
                                    bgcolor: '#43b5a2',
                                    color: '#fff',
                                    borderRadius: '4px',
                                    height: '30px',
                                    width: '31px',
                                    padding: '4px',
                                }}>
                                    <Iconify icon="bx:save" />
                                </IconButton>
                            </Tooltip>
                        )}
                    </Stack>
                    {loadingCount > 0 && (<LoadingProgressBar />)}
                    {open && <PopUpHandle open={open} handleClose={handleClose} error={error} errorCode={errorCode} />}
                </Box>



            </form>
        </div >
    )
}
